import type { ComponentType } from 'react';
import { CalendarThumbnail } from './CalendarThumbnail';
import { CardsThumbnail } from './CardsThumbnail';
import { DayColumnsThumbnail } from './DayColumnsThumbnail';
import { ListImagesThumbnail } from './ListImagesThumbnail';
import { ListThumbnail } from './ListThumbnail';
import { MonthCardsThumbnail } from './MonthCardsThumbnail';
import { PosterThumbnail } from './PosterThumbnail';
import { SideBySideThumbnail } from './SideBySideThumbnail';
import { WeekColumnsThumbnail } from './WeekColumnsThumbnail';
import { WeekSplitThumbnail } from './WeekSplitThumbnail';

export type ThumbnailKind =
  | 'list'
  | 'listImages'
  | 'sideBySide'
  | 'cards'
  | 'calendar'
  | 'monthCards3'
  | 'monthCards6'
  | 'monthCards12'
  | 'weekSplit'
  | 'weekColumns'
  | 'dayColumns'
  | 'poster';

// Each layout kind renders its own skeleton module inside the shared frame. The
// month-card kinds share one parameterized skeleton, varied by row count so the
// 3/6/12-box grids are told apart at a glance.
export const THUMBNAILS: Record<ThumbnailKind, ComponentType> = {
  list: ListThumbnail,
  listImages: ListImagesThumbnail,
  sideBySide: SideBySideThumbnail,
  cards: CardsThumbnail,
  calendar: CalendarThumbnail,
  monthCards3: () => <MonthCardsThumbnail rows={1} />,
  monthCards6: () => <MonthCardsThumbnail rows={2} />,
  monthCards12: () => <MonthCardsThumbnail rows={4} />,
  weekSplit: WeekSplitThumbnail,
  weekColumns: WeekColumnsThumbnail,
  dayColumns: DayColumnsThumbnail,
  poster: PosterThumbnail,
};
